import { formatAndSplitDate } from "components/common/functions";
import AgodaLogo from "img/partners/agoda_logo.png";
import AirbnbLogo from "img/partners/airbnb_logo.svg";
import BookingLogo from "img/partners/B_logo.png";
import ExpediaLogo from "img/partners/expedia_logo.svg";
import HotelsLogo from "img/partners/hotels_logo.png";
import HostelworldLogo from "img/partners/hw_logo.png";
import TripLogo from "img/partners/trip_icon.png";
import VioLogo from "img/partners/vio_logo.png";
import { wrapExpediaUrl } from "./affiliates/expediaUrl";
import { buildHostelworldUrl } from "./affiliates/hostelworldUrl";
import { formatPlaceUrl } from "./urlUtils";

export function getPartnerUrl(name: string, city: string, startDate?: string, endDate?: string, username?: string): string {
	const s = formatAndSplitDate(startDate);
	const e = formatAndSplitDate(endDate);
	const c = city?.replace(/ /g, "+");

	let rawUrl: string;
	switch (name) {
		case "Booking.com":
			// No label here — formatPlaceUrl (below) is the single source of truth for stamping
			// it, and only does so when username is a truthy non-empty string (never `label=undefined`).
			rawUrl = `https://www.booking.com/searchresults.en-us.html?aid=1787423&ss=${c}&checkin_year=${s.year}&checkin_month=${s.month}&checkin_monthday=${s.day}&checkout_year=${e.year}&checkout_month=${e.month}&checkout_monthday=${e.day}`;
			break;
		case "Expedia":
			rawUrl = wrapExpediaUrl(
				`https://www.expedia.com/Hotel-Search?adults=2&destination=${city}&endDate=${e.year}-${e.month}-${e.day}&sort=RECOMMENDED&startDate=${s.year}-${s.month}-${s.day}`
			);
			break;
		case "Hostelworld":
			rawUrl = buildHostelworldUrl(city);
			break;
		case "Airbnb":
			rawUrl = `https://www.airbnb.com/s/${city}/homes?date_picker_type=calendar&checkin=${s.year}-${s.month}-${s.day}&checkout=${e.year}-${e.month}-${e.day}`;
			break;
		case "Vio.com":
			rawUrl = `https://www.vio.com/Hotel/Search?city=${city}&checkIn=${s.year}-${s.month}-${s.day}&checkOut=${e.year}-${e.month}-${e.day}&utm_source=stipplio`;
			break;
		case "Hotels.com":
			rawUrl = `https://www.hotels.com/search.do?destination=${city}&check-in=${s.year}-${s.month}-${s.day}&check-out=${e.year}-${e.month}-${e.day}`;
			break;
		case "Trip.com":
			rawUrl = `https://www.trip.com/hotels/list?city=${city}&checkin=${s.year}-${s.month}-${s.day}&checkout=${e.year}-${e.month}-${e.day}`;
			break;
		case "Agoda":
			rawUrl = `https://www.agoda.com/search?city=${city}&checkIn=${s.year}-${s.month}-${s.day}&checkOut=${e.year}-${e.month}-${e.day}`;
			break;

		case "GetYourGuide":
			rawUrl = `https://www.getyourguide.com/s/?q=${encodeURIComponent(city)}&date_from=${s.year}-${s.month}-${s.day}&date_to=${e.year}-${e.month}-${e.day}&adults=1&searchSource=8`;
			break;
		case "Viator":
			rawUrl = `https://www.viator.com/search/${encodeURIComponent(city)}`;
			break;

		default:
			return "";
	}

	// Ensures the affiliate ID (and, for Booking.com, the per-user attribution label) is
	// present and correct via the single source of truth (formatPlaceUrl only touches
	// booking.com/getyourguide.com/viator.com — other partners above pass through unchanged).
	return formatPlaceUrl(rawUrl, username);
}

// ─── Constants ───────────────────────────────────────────────────────────────

export const PARTNERS = [
	{ name: "Booking.com", logo: BookingLogo, popular: true },
	{ name: "Expedia", logo: ExpediaLogo, popular: false },
	{ name: "Hostelworld", logo: HostelworldLogo, popular: false },
	{ name: "Agoda", logo: AgodaLogo, popular: false },
	{ name: "Hotels.com", logo: HotelsLogo, popular: false },
	{ name: "Vio.com", logo: VioLogo, popular: false },
	{ name: "Trip.com", logo: TripLogo, popular: false },
	{ name: "Airbnb", logo: AirbnbLogo, popular: false },
];
